export var OUNCE_VARIANTS = ['oz', 'ounce', 'ounces'];
export var CUP_VARIANTS = ['cup', 'cups'];
export function isOunce(unit) {
    var _a;
    var u = (_a = unit === null || unit === void 0 ? void 0 : unit.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return OUNCE_VARIANTS.includes(u);
}
export function isCup(unit) {
    var _a;
    var u = (_a = unit === null || unit === void 0 ? void 0 : unit.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return CUP_VARIANTS.includes(u);
}
